import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import SwitchControlSingleDecorator from '../../../../shared/switch-control/single/main';

const propTypes = {
	intl: PropTypes.func,
	statusesFilters: PropTypes.array,
	chooseStatusesFilter: PropTypes.func
};

const FilterStatuses = ({
	intl,
	statusesFilters,
	chooseStatusesFilter
}) => (
	<SwitchControlSingleDecorator>
		{ statusesFilters.map(filter => (
			<button
				key={filter.name}
				onClick={() => chooseStatusesFilter(filter.name)}
				className={cn('ui-btn ui-btn-secondary', filter.active && 'active')}>{ intl(filter.placeholder) }</button>
		)) }
	</SwitchControlSingleDecorator>
);

FilterStatuses.propTypes = propTypes;

export default FilterStatuses;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/components/quick-filters/statuses/main.js